import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import it from './locales/it.json';
import en from './locales/en.json';
import es from './locales/es.json';

export const LANGUAGES = [
  { code: 'it', label: 'Italiano', short: 'IT', flag: '🇮🇹' },
  { code: 'en', label: 'English', short: 'EN', flag: '🇬🇧' },
  { code: 'es', label: 'Español', short: 'ES', flag: '🇪🇸' },
];

const SUPPORTED = LANGUAGES.map((l) => l.code);
let saved = (typeof window !== 'undefined' && localStorage.getItem('sila_lang')) || 'it';
if (!SUPPORTED.includes(saved)) saved = 'it';

const applyHtmlLang = (lng) => {
  if (typeof document !== 'undefined') document.documentElement.setAttribute('lang', lng);
};

i18n.use(initReactI18next).init({
  resources: {
    it: { translation: it },
    en: { translation: en },
    es: { translation: es },
  },
  lng: saved,
  fallbackLng: 'it',
  supportedLngs: SUPPORTED,
  interpolation: { escapeValue: false },
});

applyHtmlLang(i18n.language);
i18n.on('languageChanged', (lng) => {
  applyHtmlLang(lng);
  try { localStorage.setItem('sila_lang', lng); } catch { /* ignore */ }
});

export default i18n;
